import { Button } from "@ui";
import style from "./FreeProxy.module.scss";
import { useEffect, useRef, useState } from "react";
import { EOperator } from "@interfaces/operator.enum";
import { OperatorSelect } from "../Tariff/components";
import { useGetOneFreeProxyMutation } from "@RTKQuery/user/purchases/purchases";
import { useGetUserQuery } from "@RTKQuery/user/auth/auth";
import { useGetUserTariffsQuery } from "@RTKQuery/user/tariffs/tariffs";
import { useNavigate } from "react-router-dom";

export function FreeProxy() {
    const navigate = useNavigate()

    const { data: user } = useGetUserQuery();

    const { data } = useGetUserTariffsQuery(void 0, {
        selectFromResult: (args) => ({
            ...args,
            data: args.data?.find(item => item.name === "Platinum")
        })
    })

    const [getOneFreeProxy, { isSuccess, isLoading, error, reset }] = useGetOneFreeProxyMutation();

    const [selectData, setSelectData] = useState({
        operator: "Не знайдено",
    });

    useEffect(() => {
        if (data?.free_proxies?.[0]) {
            setSelectData({
                operator: data.free_proxies[0].operator
            })
        }
    }, [data])

    const counter = useRef<number>(0);

    if (user?.count_rented_proxies || counter.current) {
        return null;
    } else {
        return (
            <div className={style.container}>
                <p className={style.label}>Отримати безкоштовний тест на 15 хвилин. <br /> Тариф Platinum</p>
                <div className="flex gap-[20px]  max-md:flex-col">
                    <div className="max-w-[400px] max-md:mb-[40px] max-md:max-w-full">
                        <OperatorSelect
                            value={{
                                operator: selectData.operator,
                                count: 0
                            }}
                            dataList={data?.free_proxies || []}
                            setValue={({operator}) => {
                                setSelectData({
                                    operator
                                })
                            }}
                            listPosition="top"
                        />
                    </div>
                    <Button
                        text="Отримати"
                        customStyle={{
                            button: "!h-[42px] !w-full !min-w-[120px]",
                            text: "!text-[15px]"
                        }}
                        onClick={() => {
                            getOneFreeProxy({ operator: selectData.operator as EOperator })
                        }}
                        successContent={
                            isSuccess
                                ? {
                                    title: "Вітаємо!",
                                    description: <p className="max-w-[260px]">Ви успішно отримали тимчасове проксі. Приємного користування!</p>,
                                    button: {
                                        text: "Перейти в мої проксі",
                                        action: () => {
                                            navigate("/")
                                        }
                                    }
                                }
                                : undefined
                        }
                        loading={isLoading}
                        errors={[
                            (error && ((extractError) => {
                                return extractError(error)
                            }))
                        ]}
                        resetStatus={() => {
                            counter.current = counter.current + 1;
                            reset();
                        }}
                    />
                </div>
            </div>
        )
    }
}